module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete_item_description":"Are you sure you want to delete this item? This item will be deleted permanently."},"id":{"delete_item_description":"Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen."}}')
  delete Component.options._Ctor
}
